export default __webpack_public_path__ + "static/media/CHILLI-BEANS.6934f3d3.jpg";